import Vue from 'vue'
import Vuex from 'vuex'
import {USER_KEY, USER_MIC} from '@/utils/consts'
import axios from 'axios'
import { Device } from "@twilio/voice-sdk";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem(USER_KEY)),
    mic: JSON.parse(localStorage.getItem(USER_MIC)),
    error: undefined,
    system: null,
    device: undefined,
  },

  mutations: {
    SET_ERROR(state, value) {
      state.error = value;
    },
    SET_USER(state, payload) {
      if (payload != null) {
        localStorage.setItem(USER_KEY, JSON.stringify(payload));
      }
      else {
        localStorage.removeItem(USER_KEY);
      }
      state.user = payload;
    },
    SET_AGENTS(state, payload) {
      var system;
      if (state.system == null) {
        system = {token: undefined, agents: null, algorithm: undefined, crmEnabled: false, pyamentEnabled: false, groups: []};
      }
      else {
        system = state.system;
      }
      system.agents = payload;
      state.system = system;
    },
    SET_SYSTEM(state, payload) {
      state.system = payload;
    },
    SET_SYSTEM_SETTINGS(state, payload) {
      var system;
      if (state.system == null) {
        system = {token: undefined, agents: null, algorithm: undefined, crmEnabled: false, paymentEnabled: false, groups: []};
      }
      else {
        system = state.system;
      }
      system.algorithm = payload.algorithm;
      system.crmEnabled = payload.crmEnabled;
      system.paymentEnabled = payload.paymentEnabled;
      state.system = system;
    },
    SET_MIC(state, mic) {
      localStorage.setItem(USER_MIC, JSON.stringify(mic));
      state.mic = mic;
    },
    SET_DEVICE(state, device) {
      state.device = device
    },
    SET_TWILIO_TOKEN(state, ttoken) {
      var system;
      if (state.system == null) {
        system = {token: undefined, agents: null, algorithm: undefined, crmEnabled: false, paymentEnabled: false, groups: []};
      }
      else {
        system = state.system;
      }
      system.token = ttoken;
      state.system = system
    }
  },

  actions: {
    login(context, payload) {
      context.commit('SET_ERROR', undefined);

      return axios.post('/api/v1/auth', {username: payload['username'], password: payload['password']})
      .then((response) => {
        context.commit('SET_USER', {'username': payload['username'], 'name': response.data['name'], 'token': response.data['token']});
      })
      .catch((error) => {
        var msg = 'Server is not available';

        if (error.response && error.response.status == 401) {
          msg = 'Invalid user or password';
        }
        context.commit('SET_ERROR', msg);
      })
    },
    logout(context) {
      context.commit('SET_ERROR', undefined);
      context.commit('SET_USER', null);
    },
    changePassword(context, payload) {
      context.commit('SET_ERROR', undefined);
      return axios.post('/api/v1/update-agent', {old: payload["old"], new: payload["new"]})
      .catch((error) => {
        var msg = 'Server is not available';

        if (error.response && error.response.status == 401) {
          msg = 'Invalid old password';
        }
        context.commit('SET_ERROR', msg);
      })
    },
    updateSystem(context, payload) {
      context.commit('SET_ERROR', undefined);
      return axios.post('/api/v1/update-system', {
        algorithm: payload["algorithm"],
        crmEnabled: payload["crmEnabled"],
        paymentEnabled: payload["paymentEnabled"],
        password: payload["password"]
      })
      .catch((error) => {
        var msg = 'Server is not available';

        if (error.response && error.response.status == 401) {
          msg = 'Invalid admin password';
        }
        context.commit('SET_ERROR', msg);
      })
    },
    async searchCallmeRequests(context, searchParams) {
      context.commit('SET_ERROR', undefined);
      let data = {};

      data['p'] = searchParams.page
      data['s'] = searchParams.size
      data['of'] = searchParams.order_by
      data['od'] = searchParams.order_desc ? 'd' : 'a'

      return axios.get('/api/v1/callmerequests', {params: data}).catch(() => {
        var msg = 'Server error';
        context.commit('SET_ERROR', msg);
      })
    },
    async searchCalls(context, searchParams) {
      context.commit('SET_ERROR', undefined);
      let data = {};
      
      if (searchParams.call_type) {
        data['d'] = searchParams.call_type
      }

      if (searchParams.from_number) {
        data['n'] = searchParams.from_number
      }

      if (searchParams.from_date) {
        data['fd'] = Date.parse(searchParams.from_date)/1000
      }

      if (searchParams.to_date) {
        data['td'] = Date.parse(searchParams.to_date)/1000
      }

      if (searchParams.agent) {
        data['a'] = searchParams.agent
      }

      data['p'] = searchParams.page
      data['s'] = searchParams.size
      data['of'] = searchParams.order_by
      data['od'] = searchParams.order_desc ? 'd' : 'a'

      return axios.get('/api/v1/search', {params: data}).catch(() => {
        var msg = 'Server error';
        context.commit('SET_ERROR', msg);
      })
    },
    updateAgents(context, agents) {
      context.commit('SET_AGENTS', agents);
    },
    updateSystemSettings(context, payload) {
      context.commit('SET_SYSTEM_SETTINGS', payload);
    },
    updateTwilioToken(context, value) {
      context.commit('SET_TWILIO_TOKEN', value);
    },
    initSystem(context, payload) {
      context.commit('SET_SYSTEM', payload);
    },
    updateSelectedMic(context, mic) {
      context.commit('SET_MIC', mic);
    },
    async checkCrmId(_context, crmId) {
      let result = 500;
      try {
        let resp = await axios.get('/api/v1/check-crm/' + crmId);
        result = resp.status;
      } catch (error) {
        if (error.response) {
          result = error.response.status;
        }
      }
      return result;
    },
    async requestTransferCall(_context, transferParams) {
      try {
        var resp = await axios.post('/api/v1/transfer-call', transferParams);
        return resp.data;
      } catch(error) {
        var msg = 'Server error';

        if (error.response) {
          if (error.response.status == 401) {
            msg = 'Unauthorized to transfer call';
          } else if (error.response.status < 500) {
            msg = error.response.data;
          }
        } else {
          msg = error.message;
        }

        return {
          'result': 'KO',
          'msg': msg
        }
      }
    },
    async setupTwilioDevice({commit}, {token, close}) {
      commit('SET_DEVICE', new Device(token, {close}));
      return true;
    },
  },

  getters: {
    user: state => state.user,
    system: state => state.system,
    error: state => state.error,
    selectedMic: state => state.mic,
    device: state => state.device,
    groups: state => state.groups
  },

  modules: {
  }
})
